import React from 'react'
import { Field } from 'redux-form'
import { DialogTitle, DialogContent, DialogActions, Button, Divider } from '@material-ui/core'

import { Input, SelectInput } from 'components'

export const SelectRangeBase = ({ onClose, handleSubmit, valid, getRangeBookings }) => (
  <form onSubmit={handleSubmit(getRangeBookings)}>

    <DialogTitle>Оберіть період бронювань</DialogTitle>

    <Divider />

    <DialogContent>
      <Field
        required
        fullWidth
        name='fromDate'
        type='date'
        label='Від'
        margin='normal'
        component={Input}
        InputLabelProps={{
          shrink: true,
        }}
      />
      <Field
        required
        fullWidth
        label='До'
        name='toDate'
        type='date'
        margin='normal'
        component={Input}
        InputLabelProps={{
          shrink: true,
        }}
      />
      <Field
        required
        fullWidth
        name='status'
        label='Статус замовлення'
        margin='normal'
        component={SelectInput}
        InputLabelProps={{
          shrink: true,
        }}
      >
        <option value='' />
        <option value='all'>Всі</option>
        <option value='paid'>Оплачені</option>
      </Field>
    </DialogContent>

    <DialogActions>
      <Button onClick={onClose} color='secondary'>
        Скасувати
      </Button>
      <Button type='submit' color='primary' disabled={!valid}>
        Підтвердити
      </Button>
    </DialogActions>

  </form>
)



// WEBPACK FOOTER //
// ./src/components/EnhancedModal/components/SelectRange/SelectRange.js